import React, { useState } from 'react';
import { refreshDiscordAvatar } from 'functions/discordAvatarRefresh';

// The flair slot before a username. A player with no flair selected shows their
// Discord avatar instead. The stored avatar URL breaks when they change avatars
// on Discord, so an avatar that fails to load is hidden and the server is asked
// for the current one.
export default function FlairOrAvatar({ flair, avatarUrl, playerId }) {
	const [failedAvatarUrls, setFailedAvatarUrls] = useState([]);
	const [refreshedAvatarUrl, setRefreshedAvatarUrl] = useState(null);

	if(!flair) {
		return null;
	}
	if(!flair.isNull) {
		return (
			<span className='flairy_holder'>
				<img className={'flairy flair-' + flair.name} src={flair.fullUrl} />
			</span>
		);
	}
	const shownAvatarUrl = refreshedAvatarUrl && !failedAvatarUrls.includes(refreshedAvatarUrl) ? refreshedAvatarUrl : avatarUrl;
	if(!shownAvatarUrl || failedAvatarUrls.includes(shownAvatarUrl)) {
		return null;
	}
	const onError = () => {
		setFailedAvatarUrls((failed) => [...failed, shownAvatarUrl]);
		if(shownAvatarUrl === avatarUrl) {
			refreshDiscordAvatar(playerId).then(setRefreshedAvatarUrl);
		}
	};
	return (
		<span className='flairy_holder'>
			<img className='flairy flairy_avatar'
			     src={shownAvatarUrl}
			     alt=''
			     onError={onError} />
		</span>
	);
}
